<template>
  <div>
    <v-dialog
      v-model="d_announ"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
      max-width="300px"
    >
      <v-card class="rounded_max">
        <v-toolbar dense flat>
          <h3>Delete Announcement</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 py-0">
          <v-container style="height: max-content">
            <p class="default_txt text-center">Are you sure?</p>
            <div class="d-flex justify-center mt-2 pb-5">
              <v-btn
                class="text-capitalize rounded-lg mr-3 pa-6"
                depressed
                dark
                outlined
                color="#006341"
                @click="$emit('close')"
                >Cancel</v-btn
              >
              <v-btn
                class="bg_default text-capitalize rounded-lg pa-6"
                depressed
                dark
                @click="deleteData"
                >Delete</v-btn
              >
            </div>
            <div style="height: 30px"></div>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
        <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
          <v-progress-circular
            indeterminate
            class="mr-2"
            color="#006341"
          ></v-progress-circular>
          <b class="color_default">Loading...</b>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "createAnnoun",
  props: ["d_announ", "inventory"],

  data() {
    return {
      loading: false,
    };
  },
  methods: {
    deleteData() {
      this.loading = true;
      let body = {
        id: this.inventory.id,
      };
      let data = {
        path: "announcement/delete",
        body: body,
      };
      this.$store
        .dispatch("chat/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("fetch");
          this.$emit("close");
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.input_hide {
  display: none;
}
.title_f {
  border: solid 1px #cccccc;
  width: 100%;
  border-radius: 8px;
  /* height: 35px; */
  padding: 8px 10px;
  margin-bottom: 10px;
}
.title_f:focus {
  outline: none;
}
</style>